import { createBrowserRouter, Navigate } from 'react-router-dom'
import { lazy } from 'react'

import { AppLayout, RoleDashboard } from '@/components/layout/AppLayout'

const LoginPage = lazy(() => import('@/pages/auth/LoginPage'))
const RegisterPage = lazy(() => import('@/pages/auth/RegisterPage'))
const ForgotPasswordPage = lazy(() => import('@/pages/auth/ForgotPasswordPage'))
const ResetPasswordPage = lazy(() => import('@/pages/auth/ResetPasswordPage'))
const VerifyEmailPage = lazy(() => import('@/pages/auth/VerifyEmailPage'))
const PurchaseListsPage = lazy(() => import('@/pages/buyer/PurchaseListsPage'))
const NewPurchaseListPage = lazy(() => import('@/pages/buyer/NewPurchaseListPage'))
const PurchaseListDetailPage = lazy(() => import('@/pages/buyer/PurchaseListDetailPage'))
const MyOffersPage = lazy(() => import('@/pages/supplier/MyOffersPage'))
const CatalogBrowsePage = lazy(() => import('@/pages/buyer/CatalogBrowsePage'))
const SubscriptionsPage = lazy(() => import('@/pages/SubscriptionsPage'))
const CompanySettingsPage = lazy(() => import('@/pages/CompanySettingsPage'))
const DiscoverPage = lazy(() => import('@/pages/supplier/DiscoverPage'))
const OrdersPage = lazy(() => import('@/pages/OrdersPage'))
const OrderDetailPage = lazy(() => import('@/pages/OrderDetailPage'))
const MessagesListPage = lazy(() => import('@/pages/MessagesListPage'))
const MessagesPage = lazy(() => import('@/pages/MessagesPage'))
const AdminSubscriptionsPage = lazy(() => import('@/pages/admin/AdminSubscriptionsPage'))
const AdminUsersPage = lazy(() => import('@/pages/admin/AdminUsersPage'))
const AdminCompaniesPage = lazy(() => import('@/pages/admin/AdminCompaniesPage'))
const AdminAuditPage = lazy(() => import('@/pages/admin/AdminAuditPage'))
const AdminOffersPage = lazy(() => import('@/pages/admin/AdminOffersPage'))
const AdminPurchaseListsPage = lazy(() => import('@/pages/admin/AdminPurchaseListsPage'))
const AdminCategoriesPage = lazy(() => import('@/pages/admin/AdminCategoriesPage'))
const AdminProductImportsPage = lazy(() => import('@/pages/admin/AdminProductImportsPage'))
const AdminReviewsPage = lazy(() => import('@/pages/admin/AdminReviewsPage'))
const AdminContactSubmissionsPage = lazy(
  () => import('@/pages/admin/AdminContactSubmissionsPage'),
)
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'))

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/verify-email', element: <VerifyEmailPage /> },
  {
    element: <AppLayout />,
    children: [
      { path: '/', element: <Navigate to="/dashboard" replace /> },
      { path: '/dashboard', element: <RoleDashboard /> },
      { path: '/purchase-lists', element: <PurchaseListsPage /> },
      { path: '/purchase-lists/new', element: <NewPurchaseListPage /> },
      { path: '/purchase-lists/:id/edit', element: <NewPurchaseListPage /> },
      { path: '/purchase-lists/:id', element: <PurchaseListDetailPage /> },
      { path: '/catalogs', element: <CatalogBrowsePage /> },
      { path: '/subscriptions', element: <SubscriptionsPage /> },
      { path: '/company-settings', element: <CompanySettingsPage /> },
      { path: '/discover', element: <DiscoverPage /> },
      { path: '/my-offers', element: <MyOffersPage /> },
      { path: '/orders', element: <OrdersPage /> },
      { path: '/orders/:id', element: <OrderDetailPage /> },
      { path: '/messages', element: <MessagesListPage /> },
      { path: '/messages/:listId', element: <MessagesPage /> },
      { path: '/admin/subscriptions', element: <AdminSubscriptionsPage /> },
      { path: '/admin/users', element: <AdminUsersPage /> },
      { path: '/admin/companies', element: <AdminCompaniesPage /> },
      { path: '/admin/audit-logs', element: <AdminAuditPage /> },
      { path: '/admin/offers', element: <AdminOffersPage /> },
      { path: '/admin/purchase-lists', element: <AdminPurchaseListsPage /> },
      { path: '/admin/categories', element: <AdminCategoriesPage /> },
      { path: '/admin/product-imports', element: <AdminProductImportsPage /> },
      { path: '/admin/reviews', element: <AdminReviewsPage /> },
      { path: '/admin/contact-submissions', element: <AdminContactSubmissionsPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
])
